import React from 'react';
import { Row, Col, Card, Form } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import flatten from 'helpers/flatten';
import { DebounceInput } from 'react-debounce-input';
import './style.css';

const Listing = ({
  fields,
  data,
  filters,
  stateFilters,
  handleFilterChange,
  actions
}) => {
  const { t } = useTranslation();
  const handlePageChange = page => handleFilterChange({ page });

  return (
    <>
      <Row>
        <Col>
          <Row className="justify-content-end">
            {filters.map((filter, k) => (
              <Col key={k} md={3}>
                <Form.Group>
                  <Form.Label>{t(`label:${filter.name}`)}</Form.Label>
                  <Form.Control
                    value={stateFilters[filter.key]}
                    onChange={e =>
                      handleFilterChange({
                        [filter.key]: e.target.value,
                        page: 1
                      })
                    }
                    as="select"
                  >
                    <option value="">{t('label:all')}</option>
                    {filter.options.map((option, k) => (
                      <option key={k} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            ))}
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>{t('label:records per page')}:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.per_page}
                  onChange={e =>
                    handleFilterChange({ per_page: e.target.value, page:1 })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3} className="ml-auto">
              <Form.Group>
                <Form.Label>{t('label:search')}:</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={stateFilters.search}
                  onChange={e => handleFilterChange({ search: e.target.value, page: 1 })}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="cards-list">
                {data.data.map((dt, k) => {
                  const data = flatten(dt);
                  return (
                    <Card.Body
                      key={k}
                      className="m-1 shadow bg-white rounded"
                      style={{ width: '250px' }}
                    >
                      <Card.Title className="text-center align-middle">
                        {fields.map((field, k) => {
                          let url;
                          switch (field.type) {
                            case 'url':
                              url = data[field.key];
                              break;
                            default:
                              url = '';
                              break;
                          }
                          if (url) {
                            return (
                              <img src={url} key={k} alt="logo" width="100" />
                            );
                          } else {
                            return (
                              <img
                                src="/logo.png"
                                key={k}
                                alt="logo"
                                width="100"
                              />
                            );
                          }
                        })}
                        <br />
                        <br />

                        {(() => {
                          const will_return = [];

                          actions.forEach((action, k) =>
                            will_return.push(action(dt, k))
                          );

                          return will_return;
                        })()}
                      </Card.Title>
                    </Card.Body>
                  );
                })}
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: data.from || '0' }} to {{ to: data.to || '0' }}{' '}
                from {{ total: data.total }} records
              </Trans>
            </Col>
            <Col className="d-flex justify-content-end">
              <Pagination
                activePage={data.current_page}
                itemsCountPerPage={data.per_page}
                totalItemsCount={data.total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Listing;
